/* eslint-disable require-jsdoc */

'use strict';

const {styleProductBadges} = require('../common');

/** 
 * Fetch the product availability message
 *  @param {jQuery} $tile - Selected Tile
 */

function productAvailability($tile) {
    var pdAvailability = $tile.find('.dynamic-product-availability').detach();
    $tile.find('.product-availability').append(pdAvailability);
}


/**
 * Fetch the product price and promotion
 * @param {*} $newTile - Selected Tile
 */
function productPriceAndPromo($newTile) {
    var pdPromotion = $newTile.find('.dynamic-product-promotion');
    var pdPrice = $newTile.find('.dynamic-product-price');
    if (pdPrice.length > 0) {
        $newTile.find('.price').empty().append(pdPrice);
    }
    if (pdPromotion.length > 0) {
        $newTile.find('.availability-and-promo .promotions').empty().append(pdPromotion);
    }
}
/**
 * Fetches product data from the new tile.
 * @param {jQuery} $newTile - The new product tile that has been loaded
 * @return {Object} gtmProductData - An object containing item_id and item_name
 */
function getProductData($newTile) {
    var gtmData = $newTile.data('gtmga4data') || $.parseJSON($newTile.attr('data-gtmga4data'));
    var gtmProductData = {
        item_id: gtmData.item_id,
        item_name: gtmData.item_name,
    }
    return gtmProductData;
}

function refreshTileMedia($newTile) {
    $newTile.find('img.lazyload').each(function () {
        if (window.lazySizes && typeof window.lazySizes.loader !== 'undefined') {
            window.lazySizes.loader.unveil(this);
        }
    });
}

function appendTileQueryParam(url, key, value) {
    var pattern = new RegExp('([?&])' + key + '=');
    if (pattern.test(url)) {
        return url;
    }

    return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + value;
}

/**
 * Adds product tile swatch and dropdown events to load a new tile.
 *
 * do the tile update by calling the url provided by the swatch or the dropdown value
 *
 * @param {jQuery} el - Selected element
 * @param {string} url - URL of current refinement
 */
function updateTile(el, url) {
    var $tile = el.closest('.js-grid-tile');
    var $tileContainer = el.closest('.pd-tile-wrapper');
    var tileUrl = appendTileQueryParam(url, 'showFeaturedContent', 'true');
    var newUrl = appendTileQueryParam(tileUrl, 'isAjaxCall', 'true');
    $tileContainer.spinner().start();
    $.ajax({
        url: newUrl,
        dataType: 'html',
        success: function (data) {
            // replace existing tile with another.
            const $newTile = $(data);
            $tile.replaceWith($newTile);
            productPriceAndPromo($newTile);
            productAvailability($tileContainer);
            refreshTileMedia($newTile);
            var gtmProductData = getProductData($newTile);
            if (gtmProductData) {
                window.gtmTagManager.gtmVariationUpdateData(gtmProductData);
            }
            $tileContainer.spinner().stop();
            styleProductBadges();
        },
        error: function () {
            $tileContainer.spinner().stop();
        }
    });
}

// pull the url from the href of the link.
function updateTileFromSwatch(swatch) {
    var url = swatch.attr('href');
    updateTile(swatch, url);
}

module.exports = {
    // register the change event for all swatch buttons on the page now, or loaded later.
    initSwatches: function () {
        // namespaced + off() so multiple bundles (homePage.js, search.js) calling this don't stack handlers.
        $(document).off('click.productVariationSwatch', '.js-swatch-button').on('click.productVariationSwatch', '.js-swatch-button', function (e) {
            e.preventDefault();
            var $swatch = $(this);
            updateTileFromSwatch($swatch);
        });
    },
    toggleColorOptions: function (){
    
        $('.toggle-colors').off('click keydown').on('click keydown', function (e) {
            // If it's a click, or keydown with Enter (13) or Space (32)
            if (e.type === 'click' || e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault(); // Prevent scrolling when Space is pressed
                const $carat = $(this);
                const $hiddenGroup = $('.swatch-hidden-group');
                $hiddenGroup.toggleClass('visible');
                $carat.toggleClass('expanded');

                if ($hiddenGroup.hasClass('visible')) {
                    $carat.attr('aria-expanded', true);
                    $carat.attr('aria-label', $carat.data('expanded'));
                    $hiddenGroup.attr('aria-hidden', false);
                } else {
                    $carat.attr('aria-expanded', false);
                    $carat.attr('aria-label', $carat.data('collapsed'));
                    $hiddenGroup.attr('aria-hidden', true);
                }
            }
        });
    }
};